export default {
  development: {
    description:
      'Une fois les aspects plus généraux du système d’IA bien planifiés, plusieurs choix devront être faits afin d’assurer un développement éthique du système d’IA. Les mesures externes au système d’IA présentées dans les autres sections de ce document sont tout aussi importantes à considérer pour éviter l’utilisation exclusive à des solutions technologiques pour prévenir des enjeux éthiques.',
    questions:
      'Comment développer un système d’IA robuste, sécuritaire et durable ?',
    title: 'Développement du système d’IA',
  },
  implementation: {
    description:
      'Maintenant que le système d’IA est développé et évalué, il est prêt à être utilisé. Toutefois, pour assurer que son utilisation se fera de façon éthique, que divers risques seront prévenus et que cette technologie sera acceptée de manière générale, plusieurs mesures doivent être prises au niveau de la mise en œuvre du système. Il s’agit ici de s’assurer que l’ensemble des parties prenantes impliquées directement ou indirectement dans le système d’IA ont les compétences nécessaires.',
    questions:
      'Comment mettre en oeuvre le système d’IA en m’assurant que les usagers sont compétents pour l’utiliser et les personnes concernées par le système d’IA sont informées de son existence ?',
    title: 'Mise en œuvre du système d’IA',
  },
  maintenance: {
    description:
      'Une fois le système d’IA déployé, il est recommandé d’assurer sa maintenance et, si nécessaire, de lui apporter les améliorations nécessaires, et ce, jusqu’à sa fin de vie. Cette étape implique autant les équipes de soutien technique et les analystes de données que le responsable de l’IA, qui doivent collaborer à assurer le bon fonctionnement du système d’IA jusqu’à la fin de son cycle de vie.',
    questions:
      'Est-ce qu’une veille et des mises à jour du système d’IA sont prévues ? À quelle fréquence ? Qui aura cette responsabilité ?',
    title: 'Maintenance et amélioration',
  },
  management: {
    description:
      'Cette phase consiste en un ensemble de mesures adoptées pour assurer que les données seront utilisées de façon appropriée tout au long de leur cycle de vie afin de protéger le public.',
    questions:
      'Comment gérer de façon éthique les données dans mon organisation ?',
    title: 'Gestion éthique des données',
  },
  planning: {
    description:
      'Avant de concevoir un système d’IA au sein de votre organisme, il faut d’abord planifier plusieurs aspects pour assurer que son développement et son utilisation se feront de façon éthique.',
    questions:
      "Comment concevoir un système d'IA en impliquant les parties prenantes concernés et en mitigeant les risques associés ?",
    title: 'Planification du système d’IA',
  },
}
